import { ResponsivePie } from "@nivo/pie";
import { ModalLossControl } from "../../Components";
import { changeModal } from "../../../../Redux/Actions";
import { store } from "../../../../Redux/Store";

import { Section, ModalContent, ContainerSection, Itens, Container, Graph, ConteinerLegend, ContentLegend, Legend, Circle, Underlined, Value, Label, Title, Item } from './styles';

import { useTranslation } from "react-i18next";

const DonutGraph3D = ({ data, dataTotal }) => {
  const { t} = useTranslation();
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const title = t(`dashboards.sub-items.loss-control.total-production`);

  return (
    <>
      
      <Container>
        {/* <div style={{ display: "flex", height: 310, flexDirection: "row", gap: 50 }}> */}
          
          {/* =========================
              GRÁFICO
          ========================= */}
          <Graph>
            <ResponsivePie
              data={data.map(d => ({
                id: d.label,
                label: d.label,
                value: d.value,
                color: d.color
              }))}
              innerRadius={0.65}
              padAngle={0}
              cornerRadius={0}
              activeOuterRadiusOffset={6}
              enableArcLabels={false}
              enableArcLinkLabels={false}
              colors={({ data }) => data.color}
              sortByValue={false}
              margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
              layers={[
                "arcs",
                ({ centerX, centerY, radius }) => (
                  <g transform={`translate(${centerX}, ${centerY})`}>
                    <text
                      textAnchor="middle"
                      dominantBaseline="central"
                      fontSize={`${radius * 0.15}px`} // escala com o raio
                      fontWeight= "600"
                      fill="#333"
                    >
                      {title}
                    </text>
                    <text
                      y={24}
                      textAnchor="middle"
                      dominantBaseline="central"
                      fontSize={`${radius * 0.15}px`} // escala com o raio
                      fontWeight="700"
                      fill="#333"
                    >
                      {total.toLocaleString("pt-BR")}
                    </text>
                  </g>
                )
              ]}
              onClick={(datum) => {
                store.dispatch(changeModal("LOSS_CONTROL_MODAL"));
              }}
            />
          </Graph>

          {/* =========================
              LEGENDA
          ========================= */}
          <ConteinerLegend>
            {data.map(item => {
              const percent = ((item.value / total) * 100).toFixed(1);
              return (
                <ContentLegend>
                  <Legend>
                    <Circle $color={item.color}/>
                    <Label>{item.label} ({percent}%)</Label>
                  </Legend>

                  <Underlined $color={item.color}/>

                  <Value $color={item.color}>
                    {item.value.toLocaleString("pt-BR")}
                  </Value>
                </ContentLegend>
              );
            })}
          </ConteinerLegend>
      </Container>

      {/* =========================
          MODAL
      ========================= */}
      <ModalLossControl name="LOSS_CONTROL_MODAL" title= {t("dashboards.sub-items.loss-control.graphic.title")} width={"440px"} height={"593px"} > 

        <ModalContent>

            <ContainerSection>
              {dataTotal?.map(item => (
                <>
                  <Section key={item.id}>
                    <Title>{t(`dashboards.sub-items.loss-control.graphic.sections.${item.name}`)}</Title>
                    <Title>{item.total}</Title>
                  </Section>

                  {item.itens?.map((subitem, subIndex) => (
                    subitem.label === '% perda efetiva' ? (
                      <Section key={subIndex}>
                        <Title>{subitem.label}:</Title>
                        <Title>{subitem.value}</Title>
                      </Section>
                    ) : (
                      <Itens key={subIndex}>
                        <Item>{subitem.label}:</Item>
                        <Item>{subitem.value}</Item>
                      </Itens>
                    )
                  ))}

                </>
              ))}
            </ContainerSection>

        </ModalContent>

      </ModalLossControl>
    </>
  );
};

export default DonutGraph3D;
